/**
 * Created by alberto on 2014-10-03.
 */
define('payment/depositAmounts',['module', 'require', 'jquery', 'all/slider', 'all/jquery/jquery.tooltip'], function (module, require, $) {
    'use strict';

    var amountsMap = {};


    function fillOptions(depositBox, defaultAmounts) {
        var amountBaseTag = 'PARAM_AMOUNT';
        depositBox.$box.find('.btn').find('input').each(function (index) {
            var updatedIndex = index + 1;
            var moneyValue = defaultAmounts[amountBaseTag + updatedIndex];
            //Hit dictionary
            amountsMap[moneyValue] = moneyValue;

            $(this).val(moneyValue);
            $(this).parent().find('span').text(placeCurrencySymbol(moneyValue, defaultAmounts));
        });
    }

    function placeCurrencySymbol(money, defaultAmounts){
        if (defaultAmounts.PARAM_CURRENCY_FORMAT_DEP === 'false'){
            return money + ' '  + defaultAmounts.PARAM_CURRENCY;
        } else {
            return defaultAmounts.PARAM_CURRENCY + ' ' + money;
        }
    }

    var amounts = {};

	amounts.fillOptions = fillOptions;

    amounts.amountsMap = function(){
        return amountsMap;
    };
    return amounts;
});

